import PizzaSummary from './PizzaSummary';

export default PizzaSummary;
